module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av486-3767559fd79afc5799db298edcddbcde.jpg";